import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { Badge, Card, PageHeader } from '../components/ui';

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div>
      <PageHeader title={`Welcome${user.displayName ? `, ${user.displayName}` : ''}`} subtitle={user.email} />

      <div className="grid gap-4 sm:grid-cols-2">
        <Card>
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-slate-900">Publishing</h3>
            {user.canPublish ? <Badge color="green">enabled</Badge> : <Badge color="amber">not enabled</Badge>}
          </div>
          <p className="mt-2 text-sm text-slate-500">
            {user.canPublish
              ? 'Your account can publish community packages via the API or this dashboard.'
              : 'An admin must approve your account before you can publish. You can still create tokens.'}
          </p>
          <Link to="/dashboard/publish" className="mt-4 inline-block text-sm font-medium text-brand-600 hover:underline">
            Manage packages →
          </Link>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-slate-900">GitHub identity</h3>
            {user.github ? <Badge color="blue">@{user.github}</Badge> : <Badge>not linked</Badge>}
          </div>
          <p className="mt-2 text-sm text-slate-500">
            Linking GitHub ties your published packages to your handle and unlocks the verified-author path.
          </p>
          <Link to="/dashboard/settings" className="mt-4 inline-block text-sm font-medium text-brand-600 hover:underline">
            {user.github ? 'Account settings' : 'Link GitHub'} →
          </Link>
        </Card>

        <Card>
          <h3 className="font-semibold text-slate-900">Access tokens</h3>
          <p className="mt-2 text-sm text-slate-500">
            Create a Personal Access Token to publish from the CLI, CI, or a SwarmAI agent.
          </p>
          <Link to="/dashboard/tokens" className="mt-4 inline-block text-sm font-medium text-brand-600 hover:underline">
            Manage tokens →
          </Link>
        </Card>

        <Card>
          <h3 className="font-semibold text-slate-900">Quickstart</h3>
          <ol className="mt-2 space-y-1 text-sm text-slate-500">
            <li>1. Create a token with the <code className="text-slate-700">publish</code> scope.</li>
            <li>2. POST your manifest to <code className="text-slate-700">/api/v1/publish</code>.</li>
            <li>
              3. Or install the <span className="font-medium text-slate-700">Hub Repo Tools</span> plugin and let your
              agent do it.
            </li>
          </ol>
        </Card>
      </div>
    </div>
  );
}
